<template>
  <div class="container">
    <div class="content">
      <div class="screen">
        <dl>
          <label>已选：</label>
          <div class="list">
            <li v-for="(s, i) in filters" :key="i" v-show="s.list.filter(i => i.selected).length > 0" :title="`${s.list.filter(i => i.selected).map(j => j.title).join('/')}`">
              <span>{{`${s.title}: ${s.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
              <i @click="cancelItemlist(s)"></i>
            </li>
            <span v-for="(s, i) in filters" :key="`s${i}`" v-show="s.list.filter(i => i.selected).length > 0">
              <span class="subList" v-for="(c, ci) in s.list" :key="ci" v-show="c.list && c.list.filter(i => i.selected).length > 0"
                :title="`${c.list && c.list.filter(i => i.selected).map(j => j.title).join('/')}`">
                <span>{{`${c.title}: ${c.list && c.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
                <i @click="cancelItemlist(c)"></i>
              </span>
            </span>
            <li v-if="timeDayData.list.filter(i => i.selected).length > 0" :title="`${timeDayData.list.filter(i => i.selected).map(j => j.title).join('/')}`">
              <span>{{`${timeDayData.title}: ${timeDayData.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
              <i @click="delTimeData()"></i>
            </li>
          </div>
          <button class="filter" @click="toggleFilter()">
            <img src="@assets/img/common/filter.svg" alt="filter" />
            <span>{{showFilter ? '收起筛选' : '展开筛选'}}</span>
            <img :src="showFilter ? icons.upward : icons.downward" alt="down" />
          </button>
        </dl>
        <div class="line" v-show="showFilter"></div>
        <div v-show="showFilter">
          <div class="mb10" v-for="(items, index) in filters" :key="index">
            <ul>
              <label>{{items.title}}</label>
              <li :class="{showSelect : items.expand}" :ref="`filter${index}`">
                <span :class="{active: item.selected}" v-for="(item, index1) in items.list" :key="index1" @click="selectItem(item, items, index1)">{{item.title}}</span>
              </li>
              <li class="btn" v-if="items.list.length > 10">
                <button @click="showSelect(items, `filter${index}`)" class="down">
                  <img :src="items.expand ? icons.upward : icons.downward" alt="icon" />
                </button>
              </li>
            </ul>
            <ul v-for="(c, i) in items.list" v-if="c.selected && c.list && c.list.length > 0" :key="i">
              <label>{{c.title}}</label>
              <li :class="{showSelect: c.expand}" :ref="`filter1${i}`">
                <span :class="{active: ci.selected}" v-for="(ci, cd) in c.list" :key="cd" @click="selectItem(ci, c)">{{ci.title}}</span>
              </li>
              <!-- <li class="btn" v-if="items.list.length > 10">
                <button @click="showSelect(c, `filter${i}`)" class="down">
                  <img :src="c.expand ? icons.upward : icons.downward" alt="icon" />
                </button>
              </li> -->
              <!-- <li :ref="`expander1${i}`" class="btn" v-show="calcExpendWidth(`filters1${i}`,`expander1${i}`)"> -->
              <li :ref="`expander${i}`" class="btn" v-show="false">
                <button @click="showSelect(c, `filter${i}`)" class="down">
                  <img :src="c.expand ? icons.upward : icons.downward" alt="icon" />
                </button>
              </li>
            </ul>
          </div>
          <ul>
            <label>发布时间</label>
            <li v-show="!this.start && !this.end">
              <span :class="{active: d.key === day.key}" v-for="(d, i) in days" :key="i" @click="selectDay(d)">{{d.title}}</span>
            </li>
            <date-picker v-show="!this.day.key" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm>
            </date-picker>
          </ul>
        </div>
      </div>
      <div class="clueList">
        <div class="nav">
          <li>
            <div class="sort">
              <span :class="{active: s.selected}" v-for="(s, i) in sorts" @click="switchSort(s)" :key="i">
                {{s.title}}
                <img src="@assets/img/common/up.svg" alt="up" v-if="s.selected" />
              </span>
            </div>
            <div class="fresh" @click="fresh()">刷新</div>
          </li>
          <li class="upload creat">
            <div class="button" @click="createClue()" v-if="hasPost">
              <img src="@assets/img/common/upload.svg" alt="create">
              {{`上传${$_syscfg.clue}`}}
            </div>
          </li>
        </div>
        <div class="filelist" ref="list">
          <empty v-if="list && list.length === 0" :msg="'暂无素材'" />
          <div class="fileItem" v-for="(f, i) in list" :key="i" @click="openDetail(f,i)" :style="{'height': `${itemHeight}px`}">
            <div v-if="f.type - 0 != 3" class="cover" :style="{'background-image': `url(${f.cover || defaultImg})`}">
              <img class="new" src="@assets/img/common/new-bold.svg" alt="new" v-if="f.is_new - 0 === 1">
              <img class="play" src="@assets/img/index/play.svg" alt="play" v-if="f.type - 0 === 2 || f.type - 0 === 3">
            </div>
            <div v-else class="cover" :style="{'background-image': `url(${f.cover || defaultMedia})`}">
              <img class="new" src="@assets/img/common/new-bold.svg" alt="new" v-if="f.is_new - 0 === 1">
              <img class="play" src="@assets/img/index/play.svg" alt="play" v-if="f.type - 0 === 2 || f.type - 0 === 3">
            </div>
            <div class="detail">
              <div class="title">
                <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="f.type - 0 === 1"><img src="@assets/img/common/videoIcon.svg" alt="video" v-if="f.type - 0 === 2"><img
                  src="@assets/img/common/audioIcon.svg" alt="audio" v-if="f.type - 0 === 3"><span>{{f.title}}</span>
              </div>
              <div class="info">
                <div class="half left number">
                  <img src="@assets/img/index/time.svg" alt="time" title="发布时间">
                  <span>{{f.raw_add_time}}</span>
                </div>
                <div class="half right">
                  <img src="@assets/img/common/repost.svg" alt="time" title="被采用情况">
                  <span class="used">
                    {{`被采用 ${f.use_num}`}}
                    <div class="usedInfo" v-if="f.use_list && f.use_list.length > 0">
                      <div class="info" v-for="(u, ui) in f.use_list || []" :key="ui" @click.stop="goPage(u)">
                        <span class="useTitle">
                          {{u.title}}
                        </span>
                        <span class="useName">
                          {{u.username}}
                        </span>
                        <span class="useDate">
                          {{u.raw_update_time}}
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
              <div class="info">
                <div class="half left">
                  <img src="@assets/img/common/xy.svg" alt="user" title="信源">
                  <span>{{f.username}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></div>
        </div>
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
    <materialDetail ref="materialDetail" />
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import pages from "@components/pages";
import empty from "@components/empty";
import DatePicker from "vue2-datepicker";
import materialDetail from "@components/materialDetail";

export default {
  components: { pages, empty, DatePicker, materialDetail },
  watch: {
    "$store.state.quickEdit": function (to) {
      this.quickEdit = to;
    },
    "$store.state.create": function (to) {
      this.create = to;
    },
    datePicker: {
      deep: true,
      handler: function (n) {
        this.page.pageIndex = 1;

        this.start = common.stampToTime(n[0]);
        this.end = this.getDayEnd(n[1]);
        this.changeTime();
      }
    }
  },
  data() {
    return {
      quickEdit: true,
      create: {
        interview: false,
        material: false,
        publish: false,
        report: false
      },
      isXnew: this.$store.state.isXnew,
      list: null,
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/audioMask.jpg"),
      page: {
        pageCount: 0,
        pageSize: 20,
        pageIndex: 1,
        total: 0
      },
      allSelected: false,
      select: false,
      backShow: false,
      showFilter: true,
      filters: [],
      expandedFilters: {}, // 用户记录已展开的类别，用于每次数据返回时保持状态
      filterOptions: {},
      days: [
        {
          title: "今天",
          key: 1
        },
        {
          title: "昨天",
          key: 2
        },
        {
          title: "前一周",
          key: 3
        }
      ],
      day: {},
      datePicker: "",
      start: "",
      end: "",
      searchOptions: {},
      sorts: [
        {
          title: "时间",
          key: "time",
          selected: true
        },
        {
          title: "被采用",
          key: "use_num",
          selected: false
        }
      ],
      icons: {
        checker: require("@assets/img/interview/checker.svg"),
        checkerOn: require("@assets/img/interview/checkerOn.svg"),
        downward: require("@assets/img/common/xiala.svg"),
        upward: require("@assets/img/common/upward.svg")
      },
      selectedTag: "",
      timeDayData: {
        title: "发布时间",
        list: []
      },
      fillWidth: 0,
      itemHeight: 0,
      hasPost: false // 是否显示上传按钮
    };
  },
  methods: {
    calcExpendWidth(i, j, index) {
      setTimeout(() => {
        if (this.filters[0].list[index].expand) {
          this.showSelect(this.filters[0].list[index], 'filter' + index)
        }
        if (this.$refs['filter1' + index]) {
          let width = 0;
          let dom = '';
          if (this.$refs['filter1' + index] && this.$refs['filter1' + index][0]) {
            dom = this.$refs['filter1' + index][0].querySelectorAll('span');
          }
          let length = 0;
          if (dom) {
            length = dom.length;
          }
          if (length > 0) {
            for (let index = 0; index < length; index++) {
              width += dom[index].getBoundingClientRect().width
            }
            if (width > this.$refs['filter1' + index][0].getBoundingClientRect().width) {
              this.$refs['expander' + index][0].style.display = 'flex'
            }
          }
        }
      }, 0)
    },
    async openDetail(f, index) {
      console.log(f)
      // 打开详情弹窗
      // const i = f.id
      // this.$refs.materialDetail.getDetail(i)
      //   .then(r => {
      //     if (r) {
      //       // this.$refs.materialDetail.open(this.getList)
      //       this.clearNew(index)
      //       this.$refs.materialDetail.open()
      //     }
      //   })
      this.clearNew(index)
      let data = {
        type: f.type,
        id: f.id,
        create: this.create,
        canEdit: false,
        quickEdit: this.quickEdit
      };
      this.$materialBox(data, this.getList);
    },
    clearNew(index) {
      this.list[index].is_new = 0;
      // console.log(index)
    },
    createClue() {
      // 上传线索
      common.jump('/creatClue?t=0', true)
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return "";
      }

      const year = s.getFullYear();
      const month = common.doubleDigit(s.getMonth() + 1);
      const day = common.doubleDigit(s.getDate());

      return `${year}-${month}-${day} 23:59:59`;
    },
    delTimeData() {
      // 删除时间选择
      this.timeDayData = {
        title: "发布时间",
        list: []
      };

      if (this.start || this.end) {
        this.datePicker = "";
      } else {
        this.day = {};
        this.calculatefitlers();
      }
    },
    fresh() {
      // 无修改刷新列表
      this.getList();
    },
    imgError(i) {
      // 图片加载状态
      this.$set(i, "cover", this.defaultImg);
    },
    goDetail(i) {
      // 去详情页
      this.$set(i, "is_new", 0);

      // 打开详情弹窗
    },
    changeTime() {
      this.calculatefitlers();
    },
    selectDay(d) {
      this.page.pageIndex = 1;

      if (d.key === this.day.key) {
        this.day = {};
      } else {
        this.day = d;
      }

      this.calculatefitlers();
    },
    addTimeData(n) {
      const timeObj = {
        days: "",
        start: "",
        end: ""
      };

      const timeFilterObj = {
        title: "发布时间",
        list: []
      };

      if (this.day.key) {
        timeObj.days = this.day.key || "";

        const dayTitle = this.day.title;
        const dayObj = {
          title: dayTitle,
          selected: true
        };
        timeFilterObj.list.push(dayObj);
      }

      if (this.start || this.end) {
        timeObj.start = this.start;
        timeObj.end = this.end;

        const dayObj = {
          title: `${timeObj.start.split(" ")[0]}~${timeObj.end.split(" ")[0]}`,
          selected: true
        };
        timeFilterObj.list.push(dayObj);
      }

      this.timeDayData = timeFilterObj;
      Object.assign(this.filterOptions, timeObj);
    },
    toggleFilter() {
      // 切换筛选框
      this.showFilter = !this.showFilter;
    },
    switchSort(i) {
      // 切换筛选
      if (i.selected) return;

      this.sorts.forEach(s => {
        this.$set(s, "selected", false);
      });

      this.$set(i, "selected", true);
      this.filterOptions["sort_by"] = i.key;
      this.getList();
    },
    selectAll() {
      // 全选／反选 列表项
      const pushlist = this.list.filter(l => {
        if (l.has_push) {
          return l;
        }
      });

      this.allSelected = !this.allSelected;

      pushlist.forEach(i => {
        this.$set(i, "selected", this.allSelected);
      });

      if (pushlist.length !== this.page.pageSize) {
        let msg = "已选中有发送权限的条目";
        if (pushlist.length === 0) {
          msg = "暂无可发送的条目";
        }

        this.$toast(msg);
        this.allSelected = false;
      }
    },
    selectOne(i) {
      // 选择／反选 列表项
      if (!i.has_push) {
        this.$toast("无发送权限，无法选中");
        return;
      }

      this.$set(i, "selected", !i.selected);

      this.$nextTick(() => {
        if (!i.selected) {
          this.allSelected = false;
        }
      });
    },
    showSelect(i, key) {
      // 展开／关闭收起某类
      this.$set(i, "expand", !i.expand);

      this.$nextTick(() => {
        this.$set(this.expandedFilters, i.key, i.expand);

        if (!i.expand) {
          this.$refs[key][0].scrollTop = 0;
        }
      });
    },
    selectItem(i, l, index) {
      // 选择／反选 过滤项
      this.page.pageIndex = 1;

      this.$set(i, "selected", !i.selected);

      // console.log(index)

      this.calcExpendWidth('', '', index);

      this.calculatefitlers();
    },
    cancelItemlist(l) {
      // 取消某类条件
      this.page.pageIndex = 1;

      l.list.forEach(i => {
        this.$set(i, "selected", false);
        i.list &&
          i.list.forEach(c => {
            this.$set(c, "selected", false);
          });
      });

      this.$nextTick(() => {
        this.calculatefitlers();
      });
    },
    // calculatefitlers() {
    //   // 计算已选项，一二级拼接传接口
    //   this.filters.forEach(f => {
    //     const ids = f.list
    //       .map(i => {
    //         if (i.selected) {
    //           if (!i.list || i.list.length === 0) {
    //             return i.key;
    //           } else {
    //             const allId = i.list
    //               .map(c => {
    //                 if (c.selected) {
    //                   return c.key;
    //                 }
    //               })
    //               .filter(k => k);

    //             allId.push(i.key);

    //             return allId.join(",");
    //           }
    //         }
    //       })
    //       .filter(j => j)
    //       .join(",");

    //     this.filterOptions[f.key] = ids || "";
    //   });

    //   this.addTimeData();
    //   this.getList();
    // },
    calculatefitlers() {
      // 计算已选项，一二级分别传接口
      this.filters.forEach(i => {
        const selected1 = [] // 一级已选
        let selected2 = [] // 二级已选
        let key2 = ''
        i.list.forEach(c => {
          if (c.selected) {
            selected1.push(c.id || c.key)
          }

          if (c.list) {
            const subSelected = []
            key2 = c.key
            c.list.forEach(s => {
              if (s.selected) {
                subSelected.push(s.id)
              }
            })
            selected2 = selected2.concat(subSelected)
          }
        })

        this.filterOptions[i.key] = selected1.join(',')
        if (key2) this.filterOptions[key2] = selected2.join(',')
      })

      this.addTimeData()
      this.getList()
    },
    getViewNum(info) {
      // 异步读取浏览数据并赋值
      const data = {
        data: info,
        hideLoading: true
      };

      common.myFetch(apis.Rpt_viewnum, data).then(r => {
        if (r) {
          const viewData = r.list;
          (this.list || []).forEach(i => {
            if (viewData[i.idstring]) {
              this.$set(i, "view_num", viewData[i.idstring].count);
              this.$set(i, "link", viewData[i.idstring].url);
            }
          });
        }
      });
    },
    getList() {
      this.list = null;
      const id = this.$route.params.id;
      let data = {
        idstring: id,
        search_option: "",
        key_words: "",
        source_pid: "",
        source_sid: "",
        start: "",
        end: "",
        days: "",
        // tag_id: "",
        category: "",
        has_file: "",
        sort_by: "time",
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      };
      Object.assign(data, this.filterOptions, this.searchOptions);

      // common.myAxios(apis.file_list, data).then(res => {
      //   if (res) {
      //     this.allSelected = false;
      //     this.list = res.list;
      //     // const info = {
      //     //   time_start: res.time_start,
      //     //   time_end: res.time_end
      //     // }
      //     // this.getViewNum(info)
      //     res.params.list_search.forEach(i => {
      //       // 返回的数据添加已展开状态，保持列表状态
      //       i.expand = this.expandedFilters[i.key];
      //       i.list &&
      //         i.list.forEach(j => {
      //           j.expand = this.expandedFilters[j.key];
      //         });
      //     });

      //     this.hasPost = res.has_add_role
      //     this.filters = res.params.list_search.filter(
      //       i => i.key != "days" && i.key != "start" && i.key != "end"
      //     );
      //     this.autoSelectTag();
      //     this.generateSearchs(res.params.top_search.option.list);
      //     this.$set(
      //       this.page,
      //       "pageCount",
      //       common.calculatePage(res.page.row_count - 0, this.page.pageSize)
      //     );
      //     this.$set(this.page, "total", res.page.row_count - 0);

      //     this.$nextTick(() => {
      //       this.calcFillWidth()
      //     })
      //   }
      // });

      // return false;

      common.myFetch(apis.file_list, data).then(res => {
        if (res) {
          this.allSelected = false;
          this.list = res.list;
          // const info = {
          //   time_start: res.time_start,
          //   time_end: res.time_end
          // }
          // this.getViewNum(info)
          res.params.list_search.forEach(i => {
            // 返回的数据添加已展开状态，保持列表状态
            i.expand = this.expandedFilters[i.key];
            i.list &&
              i.list.forEach(j => {
                j.expand = this.expandedFilters[j.key];
              });
          });

          this.hasPost = res.has_add_role
          this.filters = res.params.list_search.filter(
            i => i.key != "days" && i.key != "start" && i.key != "end"
          );
          this.autoSelectTag();
          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);

          this.$nextTick(() => {
            this.calcFillWidth()
          })
        }
      });
    },
    autoSelectTag() {
      // 自动选中标签（从详情页回来时）
      if (!this.selectedTag) return;

      const tags = this.filters.filter(i => i.key === "tag_id")[0].list;
      let tag = {};
      tags.forEach(i => {
        if (this.selectedTag === i.title) {
          tag = i;
        }
      });

      this.selectedTag = "";
      this.selectItem(tag);
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    calcFillWidth() {
      // 计算填充元素宽度
      const list = this.$refs.list
      if (!list || !list.getBoundingClientRect()) return
      const listWidth = list.getBoundingClientRect().width
      let fillWidth = 0
      const itemWidth = 240  // item dom宽度
      const itemGap = 30  //item 边距
      const listGap = 30 // list左右边距
      const countsPerPage = this.list.length || 20  //每页的item数量
      const containerWidth = listWidth - listGap  //容器实际宽度（dom宽度 - 左右padding）
      const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap))  //每行item数量
      const countsLastLine = countsPerPage % countsPerRow || countsPerRow //最后一行的item数量
      const itemRatio = 270 / 240
      const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap
      const itemHeightNow = (itemWidthNow) * itemRatio

      fillWidth = countsPerRow === countsLastLine ? 0 : ((countsPerRow - countsLastLine) * (itemWidthNow + itemGap))

      this.fillWidth = fillWidth
      // this.itemHeight = itemHeightNow
      this.itemHeight = (((listWidth/countsPerRow)-14)*9/16)+126;
      console.log('list', itemWidthNow, itemHeightNow, countsPerRow)
    },
    addCalcEvent() {
      // 监听list dom宽度变化
      window.addEventListener('resize', () => {
        this.calcFillWidth()
      })
    },
    goPage(u) {
      // 跳转被采用报道详情页
      let page = '' // report: reportDetail, material: clueDetail

      if (u.use_type === 'report') {
        page = 'reportDetail'
      } else if (u.use_type === 'material') {
        page = 'clueDetail'
      } else if (u.use_type === 'publish') {
        page = 'publishDetail'
      }

      common.jump(`/${page}?d=${u.id}`, true)
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    this.selectedTag = this.$route.params.tag;
    this.getList();
    this.addCalcEvent()
  },
  created() {
    this.create = this.$store.state.create;
    this.quickEdit = this.$store.state.quickEdit;
  }
};
</script>

<style src="@assets/css/file/material.less" lang="less" scoped></style>
